import { useContext } from 'react'
import { Box, useTheme, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { ChurnRateContext } from 'src/context/gamePlayInsights/churnRate'
import { CohortsContext } from 'src/context/gamePlayInsights/cohorts'
import ChartView from './chartView'
import { LoadingComponent, ChartTypeToggleGroup } from 'src/components'

const getUseStyles = (theme: Theme) =>
  makeStyles(() => {
    return {
      contentBottom: {
        position: 'relative',
        width: '100%',
      },
      searchList: {
        zIndex: 1,
      },
      loadingMask: {
        display: 'flex',
        position: 'absolute',
        width: '100%',
        justifyContent: 'center',
        height: '100%',
        alignItems: 'center',
        zIndex: 9,
        background: theme.palette.custom?.maskBackground,
      },
    }
  })
const MiddleChart = (): JSX.Element => {
  // const
  const { state } = useContext(ChurnRateContext)
  const { state: cohortsState, dispatch: cohortsDispatch } =
    useContext(CohortsContext)
  const theme: Theme = useTheme()
  const useStyles = getUseStyles(theme)
  const classes = useStyles()

  // returns
  return (
    <Box className={classes.contentBottom}>
      {state.churnThirtyLoading && (
        <Box className={classes.loadingMask}>
          <LoadingComponent />
        </Box>
      )}

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
        }}
      >
        <Box
          sx={{
            fontSize: '20px',
            lineHeight: '36px',
            fontWeight: 500,
            padding: '0 4px',
          }}
        >
          Churn Rate
        </Box>
        <ChartTypeToggleGroup
          value={cohortsState.newChartType}
          onChange={(chartType: string) => {
            cohortsDispatch({ type: 'newChartType', payload: chartType })
          }}
        />
      </Box>
      <Box marginTop="26px">
        <ChartView id="chart" width="100" />
      </Box>
    </Box>
  )
}

export default MiddleChart
